export default "__VITE_ASSET__b10bc204__"